// React
import { useState } from "react";
import { useTranslation } from "react-i18next";

// MUI
import { Stack, Typography } from "@mui/material";
import { QrCode2 } from "@mui/icons-material";

// Components
import { MNButton } from "Common/Components";
import RenderQRCode from "./RenderQRCode";

// Styles
import styles from "./styles";
import { buttonStyles } from "Common/Styles";

const QRCode = ({ onSuccess }) => {
  const { t } = useTranslation();
  const [isDialogueOpen, setIsDialogueOpen] = useState(false);

  return (
    <>
      <Stack
        direction={{ xs: "column-reverse", md: "row" }}
        sx={styles.qrStack}
        spacing={1}
      >
        <Typography sx={styles.scanButtonHeader}>
          {t("qrcode.instructions")}
        </Typography>
        <MNButton
          ariaLabel={"qrcode.scanButton"}
          sx={buttonStyles.outlineGreenActionButton}
          onClick={() => setIsDialogueOpen(true)}
        >
          <QrCode2 />
          {t("qrcode.scanButton")}
        </MNButton>
      </Stack>
      {isDialogueOpen && (
        <RenderQRCode
          onSuccess={onSuccess}
          onDialogClose={() => setIsDialogueOpen(false)}
        />
      )}
    </>
  );
};
export default QRCode;
